import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../common.module.css";
import { authClient } from "./defaults";

export default function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  const validateEmailFormat = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email) {
      setError("Please provide your email address.");
      setShowPopup(true);
      return;
    }

    if (!validateEmailFormat(email)) {
      setError("Please provide a valid email address.");
      setShowPopup(true);
      return;
    }

    setLoading(true);
    setError("");
    setPopupMessage("");

    try {
      const response = await authClient.post(
        "/login-or-magiclink",
        { email },
        { withCredentials: true }
      );

      if (response.status === 200) {
        setPopupMessage("Magic link sent! Please check your email to log in.");
        setEmail("");
        setShowPopup(true);
      }
    } catch (err) {
      if (err.response) {
        const status = err.response.status;
        const message = err.response.data?.message;

        if (status === 400) {
          setError(message || "Invalid email address.");
        } else if (status >= 500) {
          setError("Server error. Please try again later.");
        } else {
          setError(message || "An error occurred. Please try again.");
        }
      } else if (err.request) {
        setError("No response from server. Please check your network connection.");
      } else {
        console.error("Unexpected error:", err);
        setError("An unexpected error occurred. Please try again.");
      }
      setShowPopup(true);
    } finally {
      setLoading(false);
    }
  };

  const closePopup = () => {
    setShowPopup(false);
    if (popupMessage) {
      navigate("/");
    }
  };

  return (
    <div className={styles.loginPageWrapper}>
      <div className={styles.leftPane}>
        <div className={styles.card}>
          <form className={styles.loginForm} onSubmit={handleLogin}>
            <h1 className={styles.title}>Login / Signup</h1>
            <input
              type="email"
              placeholder="Email"
              className={styles.inputField}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button className={styles.button} type="submit" disabled={loading}>
              {loading ? "Sending magic link..." : "Send Magic Link"}
            </button>
          </form>
        </div>
      </div>

      <div className={styles.rightPane} style={{ backgroundImage: "url('/loginrightbg.svg')" }}>
        <div className={styles.loginOverlayContent}>
          <h2 className={styles.loginOverlayHeading}>Welcome to SpecWizard</h2>
          <p className={styles.loginOverlaySubtext}>
            We are building Specwizard with feedback
            from the best devs in the world.
          </p>
        </div>
      </div>

      {showPopup && (
        <div className={styles.popupOverlay}>
          <div className={styles.popup}>
            <h3>{popupMessage ? "Success" : "Error"}</h3>
            <p>{popupMessage || error}</p>
            <button onClick={closePopup} className={styles.popupButton}>
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
